import { SvgIcon, SvgIconProps } from '@mui/material';
import { ReactElement } from 'react';
import { Color } from 'shared/utils/colors';

// `CreateNewFolder` is one path. The folder and the plus are split so the
// folder can take the brand color while the plus stays black.
const FOLDER_PATH =
  'M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2z';
const PLUS_PATH = 'M19 14h-3v3h-2v-3h-3v-2h3V9h2v3h3z';

/** Folder-add icon: brand-yellow folder (`Color.primaryOrange`), black plus. */
export function ChooseFromDocumentationIcon({
  sx,
  ...props
}: SvgIconProps): ReactElement {
  return (
    <SvgIcon
      {...props}
      sx={[
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
        {
          // The tile sets `color: text.primary`, and SvgIcon paints with
          // `currentColor`. These rules win over that inherited fill.
          '& .documentation-icon-folder': { fill: Color.primaryOrange },
          '& .documentation-icon-plus': { fill: Color.black },
        },
      ]}
    >
      <path className='documentation-icon-folder' d={FOLDER_PATH} />
      <path className='documentation-icon-plus' d={PLUS_PATH} />
    </SvgIcon>
  );
}
